export class TranslationItem {
  public constructor(public key: string, public value: string) {}
}
